import { AuditOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import ModalUpdateBill from 'components/UpdateBill';
import { billingSelectors, workSpaceSelectors } from 'containers/App/selectors';
import moment from 'moment';
import { getStatusBill } from 'pages/Dashboard/thunks';
import { FC, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { HeaderBilling, SearchBilling, Pagination, TableBilling } from 'components';
import { MedicalSearchRequest } from '../../types';
import { resetSearchValue, setCurrentPage, setSearchValue, updateDataPayment } from './slices';
import { Wrapper } from './styles';
import { getBillingItems } from './thunk';

const BillingProcess: FC = () => {
  const [openModalUpdateBill, setModalUpdateBill] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { items, totalItems, currentPage, searchValue } = useSelector(billingSelectors);
  const { statusBill, loadingStatusBill } = useSelector(workSpaceSelectors);
  useEffect(() => {
    dispatch(getBillingItems({ pageNumber: currentPage, searchValue: searchValue }));
  }, [dispatch, currentPage, searchValue]);

  useEffect(() => {
    return () => {
      if (history.location.pathname !== '/billing_process/register') {
        dispatch(resetSearchValue());
      }
    };
  }, [dispatch, history.location.pathname]);

  useEffect(() => {
    dispatch(getStatusBill());
    return () => {
      dispatch(updateDataPayment(undefined));
    };
  }, [dispatch]);

  const changePage = useCallback(
    (pageNumber: number) => {
      dispatch(setCurrentPage(pageNumber));
    },
    [dispatch],
  );

  const onSearch = (value: MedicalSearchRequest) => {
    dispatch(setSearchValue(value));
    dispatch(setCurrentPage(1));
  };

  return (
    <Wrapper>
      <HeaderBilling title="請求処理" icon={AuditOutlined}>
        <SearchBilling onSearch={onSearch} />
      </HeaderBilling>
      <div className="header-choose extraLargeFont">
        <div className="wrap-label">
          医療機関一覧
          <span className="standardFont info">医療機関を選択して処理を開始してください。</span>
        </div>
        {!loadingStatusBill ? (
          <div className="wrap-date">
            <p className="date">
              {moment().subtract(1, 'M').format('YYYY年MM月')}の請求書
              <b>
                【
                {statusBill?.value === '---'
                  ? '---'
                  : statusBill?.value === moment().subtract(1, 'M').format('YYYYMM')
                  ? '確定'
                  : '請求処理中'}
                】
              </b>
            </p>
            {statusBill?.value !== '---' && statusBill?.value !== moment().subtract(1, 'M').format('YYYYMM') ? (
              <Button className="btn-update-bill" onClick={() => setModalUpdateBill(true)}>
                請求書を確定する
              </Button>
            ) : null}
          </div>
        ) : null}
      </div>
      <div className="section">
        <Pagination totalItems={totalItems} page={currentPage} onChangePage={changePage} />
        <div className="table">
          <TableBilling items={items} />
        </div>
      </div>
      <ModalUpdateBill visible={openModalUpdateBill} eventActive={setModalUpdateBill} />
    </Wrapper>
  );
};
export default BillingProcess;
